import React, { useEffect, useState } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { CombinationText, ScanIconWrap, AICohortText } from './styled';
import { Tooltip } from 'antd';
import ErrorIcon from '@icons/noc/threshold-critical.svg';
import { getConfigListForMetric } from '@src/api/aiAlerts';
import { totalCombinationsAtom } from '@src/components/ai-cohorts/atoms';
import { getCardinalityText } from '@src/components/ai-cohorts/utils';
import { aiCohortDrawerAtom } from './SensitivityControl/atoms';
import { DPI_DEFAULT_AI_COHORT_METRIC } from '../constants';
import { isAppModule } from '@src/utils/constants';
import { ApartmentOutlined } from '@ant-design/icons';

export default function DimensionScan() {
  const [isLoading, setLoading] = useState(true);
  const [totalCombinations, setTotalCombinations] = useAtom(totalCombinationsAtom);
  const isDataError = !isLoading && totalCombinations === 0;

  const tooltipMsg = isDataError && 'Error fetching from the system or traffic may be too low.';
  const setOpenAICohortDrawer = useSetAtom(aiCohortDrawerAtom);

  useEffect(() => {
    setLoading(true);
    getConfigListForMetric({ metrics: [] }).then((data) => {
      setTotalCombinations(data?.data?.aiAlertsConfig?.[0]?.totalCombinations);
      setLoading(false);
    });
  }, [setTotalCombinations]);

  const handleAICohortClick = (e) => {
    e.stopPropagation(); // Prevent any parent element click handlers
    setOpenAICohortDrawer({
      open: true,
      metrics: isAppModule ? [DPI_DEFAULT_AI_COHORT_METRIC] : [],
      key: isAppModule ? DPI_DEFAULT_AI_COHORT_METRIC : '',
      isFlow: false,
    });
  };

  return (
    <Tooltip title={tooltipMsg}>
      <div>
        <CombinationText
          isLoading={isLoading}
          onClick={!isLoading && !isDataError ? handleAICohortClick : undefined}
          isError={isDataError}
          isLink
          style={{ display: 'inline-block' }}
        >
          {
            <ScanIconWrap>
              <ApartmentOutlined />
            </ScanIconWrap>
          }
          {isDataError && <ErrorIcon />}
          {getCardinalityText(totalCombinations, 2, isLoading, isDataError)}
        </CombinationText>
      </div>
      <AICohortText>(AI Cohorts)</AICohortText>
    </Tooltip>
  );
}
